// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/mask_region.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/mask_region.proto.
 */
export const file_vision_generations_v1_mask_region: GenFile = /*@__PURE__*/
  fileDesc("Cid2aXNpb24vZ2VuZXJhdGlvbnMvdjEvbWFza19yZWdpb24ucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEiHQoFUG9pbnQSCQoBeBgBIAEoAhIJCgF5GAIgASgCIkQKDUxhc3NvR2VvbWV0cnkSMwoGcG9pbnRzGAEgAygLMiMucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5Qb2ludCJZCgtCcnVzaFN0cm9rZRIVCg1zaXplX2ZyYWN0aW9uGAEgASgCEjMKBnBvaW50cxgCIAMoCzIjLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuUG9pbnQiSwoNQnJ1c2hHZW9tZXRyeRI6CgdzdHJva2VzGAEgAygLMikucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5CcnVzaFN0cm9rZSKBAgoKTWFza1JlZ2lvbhIRCglyZWdpb25faWQYASABKAkSDAoEbmFtZRgCIAEoCRINCgVjb2xvchgDIAEoCRIOCgZwcm9tcHQYBCABKAkSGgoScmVmZXJlbmNlX2Fzc2V0X2lkGAUgASgJEg8KB3Zpc2libGUYBiABKAgSPAoFbGFzc28YByABKAsyKy5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkxhc3NvR2VvbWV0cnlIABI8CgVicnVzaBgIIAEoCzIrLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuQnJ1c2hHZW9tZXRyeUgAQgoKCGdlb21ldHJ5YgZwcm90bzM");

/**
 * @generated from message protos.vision.generations.v1.Point
 */
export type Point = Message<"protos.vision.generations.v1.Point"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;
};

/**
 * Describes the message protos.vision.generations.v1.Point.
 * Use `create(PointSchema)` to create a new message.
 */
export const PointSchema: GenMessage<Point> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_mask_region, 0);

/**
 * @generated from message protos.vision.generations.v1.LassoGeometry
 */
export type LassoGeometry = Message<"protos.vision.generations.v1.LassoGeometry"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.Point points = 1;
   */
  points: Point[];
};

/**
 * Describes the message protos.vision.generations.v1.LassoGeometry.
 * Use `create(LassoGeometrySchema)` to create a new message.
 */
export const LassoGeometrySchema: GenMessage<LassoGeometry> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_mask_region, 1);

/**
 * @generated from message protos.vision.generations.v1.BrushStroke
 */
export type BrushStroke = Message<"protos.vision.generations.v1.BrushStroke"> & {
  /**
   * @generated from field: float size_fraction = 1;
   */
  sizeFraction: number;

  /**
   * @generated from field: repeated protos.vision.generations.v1.Point points = 2;
   */
  points: Point[];
};

/**
 * Describes the message protos.vision.generations.v1.BrushStroke.
 * Use `create(BrushStrokeSchema)` to create a new message.
 */
export const BrushStrokeSchema: GenMessage<BrushStroke> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_mask_region, 2);

/**
 * @generated from message protos.vision.generations.v1.BrushGeometry
 */
export type BrushGeometry = Message<"protos.vision.generations.v1.BrushGeometry"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.BrushStroke strokes = 1;
   */
  strokes: BrushStroke[];
};

/**
 * Describes the message protos.vision.generations.v1.BrushGeometry.
 * Use `create(BrushGeometrySchema)` to create a new message.
 */
export const BrushGeometrySchema: GenMessage<BrushGeometry> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_mask_region, 3);

/**
 * @generated from message protos.vision.generations.v1.MaskRegion
 */
export type MaskRegion = Message<"protos.vision.generations.v1.MaskRegion"> & {
  /**
   * @generated from field: string region_id = 1;
   */
  regionId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * @generated from field: string prompt = 4;
   */
  prompt: string;

  /**
   * @generated from field: string reference_asset_id = 5;
   */
  referenceAssetId: string;

  /**
   * @generated from field: bool visible = 6;
   */
  visible: boolean;

  /**
   * @generated from oneof protos.vision.generations.v1.MaskRegion.geometry
   */
  geometry: {
    /**
     * @generated from field: protos.vision.generations.v1.LassoGeometry lasso = 7;
     */
    value: LassoGeometry;
    case: "lasso";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.BrushGeometry brush = 8;
     */
    value: BrushGeometry;
    case: "brush";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.generations.v1.MaskRegion.
 * Use `create(MaskRegionSchema)` to create a new message.
 */
export const MaskRegionSchema: GenMessage<MaskRegion> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_mask_region, 4);

